import React, { useEffect, useRef, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { useTranslation } from "react-i18next";
import '../pickers/pickers.scss';

const DatePicker = (props) => {
    const { t, i18n } = useTranslation();
    const [date, setDate] = useState(props.date ? new Date(props.date) : null);
    const toast = useRef(null);

    addLocale('tr', {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: ['pazartesi', 'salı', 'çarşamba', 'perşembe', 'cuma', 'cumartesi', 'pazar'],
        dayNamesShort: ['pzt', 'sal', 'çar', 'per', 'cum', 'cmt', 'paz'],
        dayNamesMin: ['P', 'S', 'Ç', 'P', 'C', 'C', 'P'],
        monthNames: ['ocak', 'şubat', 'mart', 'nisan', 'mayıs', 'haziran', 'temmuz', 'ağustos', 'eylül', 'ekim', 'kasım', 'aralık'],
        monthNamesShort: ['ock', 'şbt', 'mrt', 'nsn', 'mays', 'hzr', 'tmz', 'ağs', 'eyl', 'ekm', 'ksm', 'arl'],
        today: 'Bugün',
        clear: 'Temizle',
    });

    useEffect(() => {
        if (props.date) {
            setDate(new Date(props.date));
        }
    }, [props.date]);

    const handleDateChange = (e) => {
        const selectedDate = e.value;
        setDate(selectedDate);
        props.selectedDate(selectedDate);
    };

    return (
        <div className="single-date-picker transition">
            <Calendar
                value={date}
                onChange={handleDateChange}
                locale={i18n.language === 'en-US' ? 'en' : 'tr'}
                showIcon
                dateFormat="dd/mm/yy"
                className="w-full transition"
                placeholder={props.placeholder}
                maxDate={props.maxDate !== undefined ? props.maxDate : undefined}
            />
        </div>
    );
}

export default DatePicker;
